<template>
  <span class="a">
    <vue-qrcode v-if="targetText" :value="targetText" :options="option" tag="img"></vue-qrcode>
  </span>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  props: ['text'],
  components: {
    VueQrcode
  },
  data() {
    return {
      targetText: '',
      option: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 4,
        scale: 2,
        width: 300,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      }
    };
  },
  watch: {
    text () {
      console.log('watchwatchwatch');
      this.generate();
    },
  },
  mounted: function (){
     this.generate();

    console.log(this.text);
  },
  methods: {
    generate: function() {
      console.log(this.text);
      this.targetText = this.text;
    }
  }
};
</script>
<style scoped>
  .a{
    width: 300px;
  }
</style>
